<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link
        class="flex text-indigo-400 group-hover:text-indigo-600"
        :href="route('qrcodes')"
      >
        <icon name="qr-code" class="w-8 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> QR
        Codes /
      </inertia-link>
      <span class="ml-1 font-medium"> Criar </span>
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input
            v-if="showOrganizations"
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pr-6 pb-8 w-full"
            label="Organização"
          >
            <option :value="null" />
            <option
              v-for="organization in organizations"
              :key="organization.id"
              :value="organization.id"
            >
              {{ organization.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.campaign_id"
            :error="form.errors.campaign_id"
            class="pr-6 pb-8 w-full"
            label="Campanha"
          >
            <option :value="null" />
            <option v-for="campaign in campaigns" :key="campaign.id" :value="campaign.id">
              {{ campaign.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pr-6 pb-8 w-full"
            label="Nome"
          />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pr-6 pb-8 w-full"
            label="Descrição"
          />
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            class="pr-6 pb-8 w-full"
            label="Código"
          />
          <text-input
            v-model="form.url"
            :error="form.errors.url"
            class="pr-6 pb-8 w-full"
            placeholder="Ex.: https://www.google.com"
            label="URL"
          />
          <div class="pr-6 pb-8 w-full">
            <label>Data Inicial:</label><br /><br />
            <datepicker
              v-model="form.start_date"
              :language="ptBR"
              :error="form.errors.start_date"
              :format="customFormatter"
              placeholder="Selecione..."
            />
          </div>
          <div class="pr-6 pb-8 w-full">
            <label>Data Final:</label><br /><br />
            <datepicker
              v-model="form.end_date"
              :language="ptBR"
              :error="form.errors.end_date"
              :format="customFormatter"
              placeholder="Selecione..."
            />
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Estado:</label>
            <select
              id="state"
              v-model="form.state_id"
              class="form-select"
              required="required"
              @change="getCities()"
            >
              <option :value="null" />
              <option v-for="state in states" :key="state.id" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Cidade:</label>
            <select id="city" v-model="form.city_id" class="form-select" required="required">
              <option :value="null" />
              <option v-for="city in cities" :key="city.id" :value="city.id">
                {{ city.name }}
              </option>
            </select>
          </div>

          <text-input
            v-model="form.lat"
            :error="form.errors.lat"
            class="pr-6 pb-8 lg:w-1/2"
            label="Latitude"
          />
          <text-input
            v-model="form.lng"
            :error="form.errors.lng"
            class="pr-6 pb-8 lg:w-1/2"
            label="Longitude"
          />

          <text-input
            v-model="form.phone"
            :error="form.errors.phone"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Fone"
          />
          <file-input
            v-model="form.photo"
            :error="form.errors.photo"
            class="pr-6 pb-8 w-full"
            type="file"
            accept="image/*"
            label="Imagem"
          />
          <select-input
            v-model="form.active"
            :error="form.errors.active"
            class="pr-6 pb-8 w-full"
            label="Ativo"
          >
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit"
            >Criar QRCode</loading-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import TextareaInput from '@/Shared/TextareaInput'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import SelectInput from '@/Shared/SelectInput'
import moment from 'moment'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  metaInfo: { title: 'Criar QRCode' },
  components: {
    Datepicker,
    TextareaInput,
    FileInput,
    LoadingButton,
    TextInput,
    SelectInput,
    Icon,
  },
  layout: Layout,
  remember: 'form',
  props: {
    campaigns: Array,
    organizations: Array,
    showOrganizations: Boolean,
  },
  data() {
    return {
      states: null,
      cities: null,
      ptBR: ptBR,
      form: this.$inertia.form({
        organization_id: null,
        campaign_id: null,
        name: null,
        description: null,
        code: Math.random().toString(36).slice(2).toUpperCase(),
        lat: null,
        lng: null,
        url: null,
        start_date: new Date(),
        end_date: new Date(), //new Date().setFullYear((new Date().getFullYear()+1)),
        photo: null,
        phone: null,
        state_id: null,
        city_id: null,
        state: null,
        active: null,
      }),
    }
  },
  mounted() {
    this.getStates()
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    store() {
      this.form.post(this.route('qrcodes.store').url())
    },
    getStates() {
      axios.get(this.route('states')).then((response) => (this.states = response.data))
    },
    getCities() {
      axios
        .get(this.route('cities'), {
          params: {
            stateId: this.form.state_id,
          },
        })
        .then((response) => (this.cities = response.data))
    },
  },
}
</script>
